// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"styles_inputContainer__2WBxg","inputLabel":"styles_inputLabel__x5BZV"};